import React from "react";

// Style
import "../../style/Terms";
import { TermsWrapper, TermContent } from "../../style/Terms";

// Images
import logo from "../../images/ic_logo.svg";

const index = () => {
  return (
    <TermsWrapper>
      <a href="/">
        <img src={logo} alt={logo} />
      </a>
      <TermContent>
        <h1>Smrt Stats Privacy Policy</h1>
        <h3>
          Your privacy is important to Smrt Football Limited ("Smrt Stats", "we", "our", or "us"), and Smrt Stats is committed to the protection of your personal information. Our Privacy Policy exists to help you understand what information Smrt Stats collects, how we collect and use it, and what choices you have.
          To make sure your personal information is secure, we communicate our privacy and security guidelines to Smrt Stats employees and strictly enforce privacy safeguards within the company.
          Please read this Privacy Policy before visiting our website, accessing or using our services or providing any personal information to Smrt Stats.
          If you do not wish to have your information used and disclosed as provided in this Privacy Policy, please refrain from providing your information and/or delete the information you may have submitted in the past. In doing so, please understand that your access to information, services and other benefits may be substantially limited. Further assistance is available via email to contact@smrtstats.com.
        </h3>

        <h2>1. COLLECTION AND USE OF PERSONAL INFORMATION</h2>
        <p>
          Personal information is data relating to a person that can be used to help uniquely identify them, either directly or indirectly. We may collect personal information from and about you, including information that you provide and automatically collected information. You may be asked to provide personal information when in contact with Smrt Stats. If you do not provide us with certain requested personal information, we may not be able to provide you with some or all of Smrt Stats' services.
        </p>
        <p>
          Smrt Stats may use your personal information to:
          <br />• Provide and customize our services
          <br />• Process your account registration and maintain your account
          <br />• Provide customer support
          <br />• Communicate with you about our services
          <br />• Administer and improve our services
          <br />• Maintain security and prevent fraud
          <br />• Meet our legal obligations
          <br />• Send you periodic updates about our services (with your consent where required by law)
        </p>
        <p>
          If you no longer wish to receive our communications, you may opt out by following the opt-out instructions included in any communication that you receive from us or by contacting <a href="mailto:contact@smrtstats.com">contact@smrtstats.com</a>.
        </p>
        <p>
          We may use your personal information for purposes such as data analysis and research to improve Smrt Stats' services and customer communications. This Privacy Policy does not cover and is not intended to restrict what we do with information that is aggregated, de-identified, or anonymized, so it is no longer associated with an individually identifiable user.
        </p>

        <h2>2. PERSONAL INFORMATION WE COLLECT</h2>
        <p>
          When you visit our website, create a registered user account, use one of our services, complete a survey, or contact us, we may collect personal information, including but not limited to:
          <br />• Name
          <br />• Email address
          <br />• Company name (optional)
          <br />• Company address (optional)
          <br />• Account preferences
          <br />• Communications on our services
        </p>
        <p>
          We may also collect website usage information when you visit our website. Website usage information helps us determine how visitors use our platform and which content is most popular. We may collect the page visited, the time, the source of the request, the type of browser making the request, and other information about your engagement with our site and services. We may also collect your IP address and your Device Identifier.
        </p>
        <p>
          When you browse our website, we may collect information about you, regardless of whether you have created a registered user account. We collect and store personal information if you register as a user or provide personal details through any form of correspondence. Smrt Stats uses this information to provide services, as well as for identification, authentication, service improvement, customer service, and research purposes.
        </p>

        <h2>3. COOKIES</h2>
        <p>
          A "cookie" is a small amount of data that often includes an anonymous unique identifier that is sent to your browser from a website and stored on your computer's hard drive. When you access this website, cookies may be sent to your web browser and stored on your computer or mobile device.
        </p>
        <p>
          We use cookies to:
          <br />• Record information about your online preferences
          <br />• Allow us to tailor our website to your interests
          <br />• Store user preferences
          <br />• Provide a more personalized experience
          <br />• Recognize when you are signed in to your Smrt Stats account
        </p>
        <p>
          You can control and delete cookies through your browser settings. The Help function within your browser should tell you how to do so. For further information about how to restrict, remove, and refuse to accept cookies, visit <a href="http://www.aboutcookies.org">www.aboutcookies.org</a> or <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </p>

        <h2>4. DATA STORAGE</h2>
        <p>
          Smrt Stats uses third-party vendors and hosting partners to provide the necessary hardware, software, networking, storage and related technology required to run the Smrt Stats website. Smrt Stats owns the code, databases and all rights therein. Smrt Stats incorporates reasonable safeguards to help protect and secure your personal information. However, no data transmission over the Internet, wireless transmission, or electronic storage of information can be guaranteed to be 100% secure.
        </p>

        <h2>5. DISCLOSURES TO THIRD PARTIES</h2>
        <p>
          Smrt Stats does not sell, trade, or otherwise transfer your personal information to third parties. We may disclose your personal information only in the following limited circumstances:
        </p>
        <h3>5.1. Service Providers</h3>
        <p>
          We may disclose your personal information to third-party service providers that provide services to us, including cloud storage services, system hosting services, data security services, payment processing services, and analytics services. These providers are contractually obligated to protect your information.
        </p>
        <h3>5.2. Legal Requirements</h3>
        <p>
          We may share your personal information when we believe that the disclosure is reasonably necessary to comply with applicable laws, regulations, legal processes, or legal requests.
        </p>
        <h3>5.3. Protection of Rights</h3>
        <p>
          We may share your personal information when we believe that the disclosure is necessary to investigate, prevent, or take action regarding illegal activities, suspected fraud, situations involving potential threats to the physical safety of any person, or violations of our Terms of Service.
        </p>
        <h3>5.4. Business Transactions</h3>
        <p>
          We may disclose your personal information in the course of following transactions: sale of assets, merger, reorganization, or similar event. Personal information that we have collected may be transferred to such an entity upon closing of the transaction.
        </p>
        <p>
          Any disclosure to third parties will only take place in accordance with applicable law and for the purposes listed. Smrt Stats is not responsible for the privacy practices of any third parties.
        </p>

        <h2>6. DATA RETENTION</h2>
        <p>
          We keep personal information only for as long as necessary to fulfill the purposes for which we have collected it as set out in this Privacy Policy, including for the purposes of satisfying any legal, accounting, or reporting requirements, unless longer retention is required by applicable law.
        </p>
        <p>
          To determine the appropriate retention period for personal information, we consider the amount, nature and sensitivity of the personal information; the potential risk of harm from unauthorized use or disclosure; the purposes for which we use the personal information; whether we can achieve those purposes through other means; and the applicable laws.
        </p>
        <p>
          We may keep an anonymized form of your personal information, which will no longer refer to you, for statistical purposes without time limits, to the extent that we have a legitimate and lawful interest in doing so.
        </p>

        <h2>7. CONFIDENTIALITY AND SECURITY</h2>
        <p>
          Smrt Stats is committed to safeguarding all personal information that you provide to us; ensuring that it remains confidential and secure; and taking all reasonable steps to ensure that personal privacy is respected. All our data is stored in electronic form on our servers and in various physical locations. We maintain reasonable physical, technical and administrative safeguards to protect your personal information from misuse, unauthorized access or disclosure, and loss or corruption.
        </p>

        <h2>8. GDPR COMPLIANCE AND YOUR RIGHTS</h2>
        <p>
          If you are in the European Union, European Economic Area, or United Kingdom, you have certain rights under data protection law, including:
        </p>
        <h3>8.1. Right to Access</h3>
        <p>
          You may have the right to obtain a copy of the personal information we hold about you.
        </p>
        <h3>8.2. Right to Rectification</h3>
        <p>
          You may request that we rectify any inaccurate and/or complete any incomplete personal information.
        </p>
        <h3>8.3. Right to Withdrawal of Consent</h3>
        <p>
          You may withdraw your consent to the processing of your personal information at any time where we rely on consent as the legal basis for processing.
        </p>
        <h3>8.4. Right to Erasure</h3>
        <p>
          You may request that we erase your personal information and we will comply, unless there is a lawful reason for not doing so.
        </p>
        <h3>8.5. Right to Object</h3>
        <p>
          You may request that we stop processing your personal information for marketing purposes or other legitimate interests.
        </p>
        <h3>8.6. Right to Data Portability</h3>
        <p>
          You may request to receive your personal information in a structured, commonly used format or request that we transfer it to another controller.
        </p>
        <p>
          To exercise any of these rights, please contact us at <a href="mailto:contact@smrtstats.com">contact@smrtstats.com</a>. You also have the right to lodge a complaint with the relevant data protection authority.
        </p>

        <h2>9. LEGAL BASIS FOR PROCESSING</h2>
        <p>
          Where Smrt Stats acts as a Data Controller, we process your data lawfully based on one or more of the following legal grounds:
          <br />1. Your consent to particular processing activities
          <br />2. Our legitimate interests as a business (except where your interests or fundamental rights override these)
          <br />3. Our compliance with a legal obligation to which we are subject
          <br />4. Processing necessary for the performance of a contract with you
        </p>

        <h2>10. INTERNATIONAL TRANSFER OF PERSONAL DATA</h2>
        <p>
          Your personal data may be transferred to and processed in countries outside the EU/EEA/UK. In these circumstances, we will ensure that your privacy rights are adequately protected by appropriate technical, organizational, contractual or other lawful means in accordance with applicable data protection laws.
        </p>

        <h2>11. CHILDREN'S PRIVACY</h2>
        <p>
          We do not knowingly collect personal information from children under age 16 (or the otherwise applicable age of digital consent in any particular jurisdiction). If we learn that we have collected personal information from a child under the applicable age of digital consent, we will delete that information.
        </p>

        <h2>12. THIRD-PARTY WEBSITES</h2>
        <p>
          Some links on the Smrt Stats website may redirect you to third-party websites and services that we do not operate. The privacy practices of these websites and services will be governed by their own privacy policies. We encourage you to review and understand their privacy policies before disclosing any personal information to them.
        </p>

        <h2>13. CHANGES TO THIS PRIVACY POLICY</h2>
        <p>
          Smrt Stats may periodically update this Privacy Policy. The most current version of the Privacy Policy will always be available at <a href="https://smrtstats.com/privacy">https://smrtstats.com/privacy</a>. We will notify you about material changes in the way we treat personal information by sending a notice to the email address specified in your account or by placing a prominent notice on our website.
        </p>

        <h2>14. CONTACT INFORMATION</h2>
        <p>
          This website is owned and operated by Smrt Football Limited.
          <br />Smrt Football Limited
          <br />13 Charlotte, Honeypark.
          <br />Dun Laoghaire, Co. Dublin, Ireland A96YF6A
          <br />Company Number: 739570
          <br />Email: <a href="mailto:contact@smrtstats.com">contact@smrtstats.com</a>
        </p>
        <p>
          For any questions or concerns regarding this Privacy Policy, please contact us at <a href="mailto:contact@smrtstats.com">contact@smrtstats.com</a>.
        </p>
        <p>
          Last Updated: 27.05.2025
        </p>
      </TermContent>
    </TermsWrapper>
  );
};

export default index;
